exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nhtml, body {\n    margin: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/shane/workspace/website/website-client/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/shane/workspace/website/website-client/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/shane/workspace/website/website-client/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles